<template>
	<div class="bigtitle" :class="{'mClass': mClass}">
		<span class="text">{{bigtitle.CHN}}</span>
	</div>
</template>

<script>
export default {
	data() {
		return {
			options: {},
		};
	},
	components: {

	},
	props: {
		bigtitle: {
			type: Object,
			default: () => ({})
		},
		mClass: {
			type: String,
			default: ''
		}
	},
	watch: {},
}
</script>
<style lang="scss">
.bigtitle {
  width:100%;
  margin: 5px 0;
	font-family: 'PuHuiTi Heavy';
  position: relative;
  .text{
    display: block;
    width: 100%;
    padding-left: 33px;
    font-size: 28px;
  }
	&.mClass {
		// margin: 30px 0 0 20px;
    background: url(~@/assets/images/index/small_title.png) no-repeat;
    background-size: 100% 100%;
	}

	// span {
	// 	font-size: 21px;
	// 	margin-left: 10px;
	// }
}
</style>